// eslint-disable-next-line no-unused-vars
import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import AttachmentContent
  from 'Components/Modals/IdentityVerificationReviewDetails/reviewDetailsContent/attachmentsContent/AttachmentsContent';

// eslint-disable-next-line no-unused-vars
const AttachmentsContentPicker = ({ resource }) => {
  return pickFunction(resource, {
    [fr.relationships.attachedDocuments.name]: () => {
      return (
        <AttachmentContent resource={resource} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default AttachmentsContentPicker;
